export let BASE_API_URL = "/api";

export const FIXED_RPM_PARTNERS = ["vivaldi", "vivaldiandroid"];

export const DATE_FORMAT = "YYYY-MM-DD";

export const setBaseURL = (baseURL: string) => {
  BASE_API_URL = `${baseURL}/api`;
};
